/**
 * Created by Roman T on 4/12/2017.
 */
var QueueSapMissingController = (function () {
    function QueueSapMissingController($scope, env, $filter, $timeout, $q, socket, DTS, DTOptionsBuilder, DTColumnBuilder, _, $compile, $state, $stateParams, notify, Dialog, settings, $mdDialog, filters) {
        var _this = this;
        this.$scope = $scope;
        this.env = env;
        this.$filter = $filter;
        this.$timeout = $timeout;
        this.$q = $q;
        this.socket = socket;
        this.DTS = DTS;
        this.DTOptionsBuilder = DTOptionsBuilder;
        this.DTColumnBuilder = DTColumnBuilder;
        this._ = _;
        this.$compile = $compile;
        this.$state = $state;
        this.$stateParams = $stateParams;
        this.notify = notify;
        this.Dialog = Dialog;
        this.settings = settings;
        this.$mdDialog = $mdDialog;
        this.filters = filters;
        this.newSearch = 'Default';
        this.removedOpps = [];
        this.triggeredOpps = [];
        this.isDownloading = false;
        this.isFilterSet = false;
        this.isFilterToggled = false;
        this.wasSapTriggered = false;
        this.showFilterBtn = false;
        this.removedOpps = [];
        this.triggeredOpps = [];
        this.rowData = {};
        this.dtInstance = {};
        this.tableData = {};
        this.filterSubStatuses = [];
        this.filterStatuses = [];
        this.filterCountries = [];
        this.filterIots = [];
        this.filterImts = [];
        this.filterActive = true;
        this.goeFilter = undefined;
        this.filters = {};
        this.deferred = this.$q.defer();
        this.filterDetails();
        this.socket.forward('sap.missing.update.done', this.$scope);
        this.$scope.$on('socket:sap.missing.update.done', function (event, data) {
            _this.dtInstance.DataTable.ajax.reload(function () {
                _this.removedOpps = [];
            }, false);
        });
        this.socket.forward('sap.missing.update.failed', this.$scope);
        this.$scope.$on('socket:sap.missing.update.failed', function (event, data) {
            _this.triggeredOpps.pop();
            _this.dtInstance.DataTable.ajax.reload(null, false);
        });
        this.socket.forward('filters.getUserFilters', this.$scope);
        this.$scope.$on('socket:filters.getUserFilters', function (event, data) {
            _this.userFilters = data;
        });
        this.socket.forward('filters.deleteProfiles', this.$scope);
        this.$scope.$on('socket:filters.deleteProfiles', function (event, data) {
            _this.userFilters = data;
            _this.allowed = false;
        });
    }
    QueueSapMissingController.prototype.$onInit = function () {
        var _this = this;
        var that = this;
        this.queueLabel = 'SAP Missing';
        this.queryId = 'sap-missing';
        this.dtColumns = this.buildColumns();
        this.removedOpps = [];
        this.triggeredOpps = [];
        this.filterToggles = {
            countries: true,
            dmtStats: true,
            dmtSubStats: true,
            goe: true,
            imts: true,
            iots: true
        };
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                function: 'FetchSavedFilters',
                script: '/queueservice/filterprofiles',
                user: this.env.user
            }
        });
        this.applyLastFilter();
        this.dtOptions = this.DTOptionsBuilder.newOptions()
            .withOption('ajax', {
            dataSrc: function (data) {
                that.tableData = data.data;
                return data.data;
            },
            url: '/api/queue/sapmissing',
            type: 'POST',
            beforeSend: function (request) {
                request.setRequestHeader('Authorization', 'Bearer ' + _this.env.user.token);
            },
            data: function (d, callback, settings) {
                d.iotFilter = that.filterIots;
                d.imtFilter = that.filterImts;
                d.queueType = that.queryId;
                d.goeFilter = that.goeFilter;
                d.activeFilter = that.filterActive;
                d.users = [("" + that.env.user.email)];
                d.countryFilter = that.filterCountries;
                d.statusFilter = that.filterStatuses;
                d.substatusFilter = that.filterSubStatuses;
            },
            complete: function (d) {
                _this.wasSapTriggered = false;
            }
        })
            .withOption('processing', true)
            .withOption('serverSide', true)
            .withOption('searchDelay', 1000)
            .withOption('createdRow', createdRow)
            .withPaginationType('full_numbers');
        function createdRow(row, data, dataIndex) {
            var OFFSET = 3;
            var thresholdDate = new Date();
            thresholdDate.setHours(0, 0, 0, 0);
            thresholdDate.setDate(thresholdDate.getDate() - OFFSET);
            var createdOn = new Date(parseInt(data.created));
            createdOn.setHours(0, 0, 0, 0);
            if (createdOn <= thresholdDate && data.substatus === 'Unassigned') {
                $(row).addClass('tblRow').css('background-color', '#ff5252');
            }
            else {
                $(row).addClass('tblRow');
            }
            var el = angular.element;
            that.$compile(el(row).contents())(that.$scope);
        }
    };
    QueueSapMissingController.prototype.buildColumns = function () {
        return [
            this.DTColumnBuilder.newColumn('soNumber')
                .withTitle('SAP'),
            this.DTColumnBuilder.newColumn('invoiceNo')
                .withTitle('Invoice Number'),
            this.DTColumnBuilder.newColumn('country')
                .withTitle('Country'),
            this.DTColumnBuilder.newColumn('opps')
                .withTitle('OPP').renderWith(this.listOpptys),
            this.DTColumnBuilder.newColumn('soDate')
                .withTitle('SO Date')
                .renderWith(this.soDates),
            this.DTColumnBuilder.newColumn('oppsParams')
                .withTitle('Submit date for payment')
                .renderWith(this.listPaymentDates),
            this.DTColumnBuilder.newColumn('oppsParams')
                .withTitle('Status')
                .renderWith(this.listStatuses),
            this.DTColumnBuilder.newColumn('oppsParams')
                .withTitle('SubStatus')
                .renderWith(this.listSubstatuses),
            this.DTColumnBuilder.newColumn('oppsParams')
                .withTitle('Government Flag')
                .renderWith(this.listGOEs),
            this.DTColumnBuilder.newColumn('retriger')
                .withTitle('Retriger').renderWith(this.resultDisplay).notSortable()
        ];
    };
    QueueSapMissingController.prototype.resultDisplay = function (data, type, full, meta) {
        if (data.disable_in_missing_q === 'undefined' || !data.disable_in_missing_q) {
            data.disable_in_missing_q = false;
        }
        if (typeof data.isResolved === 'undefined' || !data.isResolved) {
            return "\n            <md-button ng-disabled=\"vm.removedOpps.indexOf(" + meta.row + ") > -1 || vm.triggeredOpps.indexOf(" + meta.row + ") > -1||  vm.wasSapTriggered || " + data.disable_in_missing_q + "\" class=\"md-raised md-primary\" ng-click=\"vm.retrigSAP(" + meta.row + ")\">Retrigger</md-button>\n            <md-button ng-disabled= \"vm.removedOpps.indexOf(" + meta.row + ") > -1 || vm.triggeredOpps.indexOf(" + meta.row + ") > -1 || vm.wasSapTriggered || " + data.disable_in_missing_q + "\" class=\"md-raised md-primary\" ng-click=\"vm.removeBtn(" + meta.row + ")\">Remove</md-button>  ";
        }
        else if (data.isResolved === 'processing') {
            return "<p>Loading...</p>";
        }
        else {
            return "<p>Already processed</p>";
        }
    };
    QueueSapMissingController.prototype.removeBtn = function (rowId) {
        var _this = this;
        var obj = {
            user_activity: {
                user: this.env.user.email,
                timestamp: Date.now(),
                action: ''
            },
            affectedOpp: this.tableData[rowId]
        };
        this.Dialog.updateValidForm(undefined, obj, 'sap-missing-remove-btn.html').then(function (dResult) {
            if (dResult.confirm) {
                _this.removedOpps.push(rowId);
                obj.user_activity.action = 'Clicked the Remove button - reason: ' + dResult.action;
                _this.socket.emit('module', {
                    module: {
                        application: 'dmt',
                        function: 'removeBtnMissingSO',
                        script: 'validation/validationTables',
                        email: _this.env.user.email,
                        data: obj,
                        user: {
                            access: _this.env.user.access,
                            email: _this.env.user.email,
                            token: _this.env.user.token
                        }
                    }
                });
            }
        });
    };
    QueueSapMissingController.prototype.retrigSAP = function (rowId) {
        this.rowData = this.dtInstance.DataTable.row(rowId).data();
        this.rowData.retriger.isResolved = 'processing';
        this.dtInstance.DataTable.row(rowId).data(this.rowData).invalidate();
        this.wasSapTriggered = true;
        this.triggeredOpps.push(rowId);
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                function: 'validateMissingSAP',
                script: 'validation/validationTables',
                email: this.env.user.email,
                data: this.rowData,
                allIDs: this.rowData.allIDs,
                token: this.env.user.token
            }
        });
    };
    QueueSapMissingController.prototype.listOpptys = function (opps, type, full, meta) {
        var htmlText = '';
        if (this.env.user.access.systemAdmin && !full.isResolved) {
            opps.forEach(function (opp) {
                htmlText += "<li>" + opp + "<md-button aria-label=\"update\" ng-click=\"vm.editOppty('" + meta.row + "&" + opp + "')\"><md-icon class=\"black_icon\" md-svg-icon=\"/public/images/wrench.svg\"></md-icon></md-button></li>";
            });
        }
        else {
            opps.forEach(function (opp) {
                htmlText += "<li>" + opp + "</li>";
            });
        }
        return htmlText;
    };
    QueueSapMissingController.prototype.listValues = function (data, type, full, meta) {
        var htmlText = '';
        data.forEach(function (el) {
            htmlText += "<li>" + el + "</li>";
        });
        return htmlText;
    };
    QueueSapMissingController.prototype.listPaymentDates = function (data, type, full, meta) {
        var htmlText = '';
        var ov = Object.keys(data).map(function (key) { return data[key]; });
        var values = ov.map(function (el) {
            return el.paymentDate ? el.paymentDate : 'N/A';
        });
        values.forEach(function (el) {
            htmlText += "<li>" + el + "</li>";
        });
        return htmlText;
    };
    QueueSapMissingController.prototype.listStatuses = function (data, type, full, meta) {
        var htmlText = '';
        var ov = Object.keys(data).map(function (key) { return data[key]; });
        var values = ov.map(function (el) {
            return el.status ? el.status : 'N/A';
        });
        values.forEach(function (el) {
            htmlText += "<li>" + el + "</li>";
        });
        return htmlText;
    };
    QueueSapMissingController.prototype.listSubstatuses = function (data, type, full, meta) {
        var htmlText = '';
        var ov = Object.keys(data).map(function (key) { return data[key]; });
        var values = ov.map(function (el) {
            return el.substatus ? el.substatus : 'N/A';
        });
        values.forEach(function (el) {
            htmlText += "<li>" + el + "</li>";
        });
        return htmlText;
    };
    QueueSapMissingController.prototype.soDates = function (data, type, full, meta) {
        if (/\d{8}/.test(data)) {
            return data.substring(6, 8) + '.' + data.substring(4, 6) + '.' + data.substring(0, 4);
        }
        else if (/\d{4}-\d{2}-\d{2}/.test(data)) {
            return data.split('-')[2] + '.' + data.split('-')[1] + '.' + data.split('-')[0];
        }
        else {
            return data;
        }
    };
    QueueSapMissingController.prototype.listGOEs = function (data, type, full, meta) {
        var htmlText = '';
        var ov = Object.keys(data).map(function (key) { return data[key]; });
        var values = ov.map(function (el) {
            return el.goe ? el.goe : 'N/A';
        });
        values.forEach(function (el) {
            htmlText += "<li>" + el + "</li>";
        });
        return htmlText;
    };
    QueueSapMissingController.prototype.editOppty = function (rowData) {
        var _this = this;
        console.log(this.env.user.access.systemAdmin);
        var oneData;
        var oldOpp;
        if (isNaN(rowData)) {
            oneData = rowData.split('&')[0];
            oldOpp = rowData.split('&')[1];
        }
        else {
            oneData = rowData;
            oldOpp = '';
        }
        var items = { affectedOpp: this.tableData[oneData], oldOpp: oldOpp, newOppty: '' };
        this.Dialog.updateValidForm(undefined, items, 'sap-missing-oppty-edit.html').then(function (dResult) {
            if (dResult.confirm) {
                items.newOppty = dResult.newOppty;
                for (var oppLn in items.affectedOpp.itemList) {
                    if (items.affectedOpp.itemList[oppLn].opp === oldOpp) {
                        items.affectedOpp.itemList[oppLn].opp = dResult.newOppty;
                    }
                }
                _this.socket.emit('module', {
                    module: {
                        application: 'dmt',
                        function: 'updateMissingSO',
                        script: 'validation/validationTables',
                        email: _this.env.user.email,
                        data: items,
                        user: {
                            access: _this.env.user.access,
                            email: _this.env.user.email,
                            token: _this.env.user.token
                        }
                    }
                });
            }
        });
    };
    QueueSapMissingController.prototype.toggleDownload = function () {
        this.isDownloading = true;
    };
    QueueSapMissingController.prototype.filterDetails = function () {
        var _this = this;
        this.env.topics.imtFilterValues = this.settings.country_list;
        this.filters.iots = this.settings.iot_list;
        this.filters.imts = this.settings.imt_list;
        this.filters.countries = this.settings.getCountryList();
        this.filters.iots.sort();
        this.filters.imts.sort();
        this.filters.countries.sort();
        this.env.topics.imtFilterValues.forEach(function (value) {
            if (value.ic === 'IOT') {
                if (!_.includes(_this.filters.iots, value.imt)) {
                    _this.filters.iots.push(value.imt);
                }
            }
            else if (value.ic === 'IMT') {
                if (!_.includes(_this.filters.imts, value.imt_name)) {
                    _this.filters.imts.push(value.imt_name);
                }
            }
            else {
                if (!_.includes(_this.filters.countries, value.country)) {
                    _this.filters.countries.push(value.country);
                }
            }
        });
        this.filters.statuses = this.settings.statuses;
        this.filters.subStatuses = this.settings.substatuses;
        this.showFilterBtn = true;
    };
    QueueSapMissingController.prototype.changeFilters = function (id) {
        var _this = this;
        if (id === 'iot') {
            this.filterImts = [];
            this.filterCountries = [];
            this.filters.imts = [];
            this.filters.countries = [];
            if (this.filterIots.length > 0) {
                this.env.topics.imtFilterValues.forEach(function (value) {
                    if (value.ic === 'IMT') {
                        if (_.includes(_this.filterIots, value.imt) &&
                            !_.includes(_this.filters.imts, value.imt_name)) {
                            _this.filters.imts.push(value.imt_name);
                        }
                    }
                    else if (value.ic === 'Country') {
                        if (_.includes(_this.filterIots, value.imt) &&
                            !_.includes(_this.filters.countries, value.country)) {
                            _this.filters.countries.push(value.country);
                        }
                    }
                });
            }
            else {
                this.env.topics.imtFilterValues.forEach(function (value) {
                    if (value.ic === 'IMT') {
                        _this.filters.imts.push(value.imt_name);
                    }
                    else if (value.ic === 'Country') {
                        _this.filters.countries.push(value.country);
                    }
                });
            }
            this.filters.imts.sort();
            this.filters.countries.sort();
        }
        else if (id === 'imt') {
            this.filterCountries = [];
            this.filters.countries = [];
            if (this.filterImts.length > 0) {
                this.env.topics.imtFilterValues.forEach(function (value) {
                    if (value.ic === 'Country') {
                        if (_.includes(_this.filterImts, value.imt_name) &&
                            !_.includes(_this.filters.countries, value.country)) {
                            _this.filters.countries.push(value.country);
                        }
                    }
                });
            }
            else {
                this.env.topics.imtFilterValues.forEach(function (value) {
                    if (value.ic === 'Country') {
                        _this.filters.countries.push(value.country);
                    }
                });
            }
        }
    };
    QueueSapMissingController.prototype.applyLastFilter = function () {
        var _this = this;
        //If there is a lastFilter element in user's profile (in browser), set the
        // filters accordingly and apply them rather than loading the default (all)
        if (this.settings.up.lastFilter) {
            angular.forEach(this.settings.up.lastFilter, function (v, k) {
                _this[k] = v;
            });
            this.isFilterToggled = true;
        }
    };
    QueueSapMissingController.prototype.setLastFilter = function () {
        var _this = this;
        //Update the User Profile's lastFilter object in session
        var lf = {};
        var filters = ['goeFilter', 'filterActive', 'filterSubStatuses', 'filterStatuses', 'filterCountries', 'filterImts', 'filterIots'];
        angular.forEach(filters, function (filter) {
            lf[filter] = _this[filter];
        });
        this.settings.up.lastFilter = lf;
    };
    QueueSapMissingController.prototype.applyFilter = function () {
        if (this.filterSubStatuses.length ||
            this.filterStatuses.length ||
            this.filterCountries.length ||
            this.filterImts.length ||
            this.filterIots.length ||
            angular.isDefined(this.goeFilter) ||
            angular.isDefined(this.filterActive)) {
            this.isFilterSet = true;
        }
        else {
            this.isFilterSet = false;
        }
        this.setLastFilter(); //Set User Profile 'last filter' for session
        this.dtInstance.DataTable.ajax.reload();
    };
    QueueSapMissingController.prototype.clearFilter = function () {
        this.filterSubStatuses = [];
        this.filterStatuses = [];
        this.filterCountries = [];
        this.filterImts = [];
        this.filterIots = [];
        this.goeFilter = undefined;
        this.dtInstance.DataTable.ajax.reload();
        delete this.settings.up.lastFilter; //Lose the last filter, too
    };
    QueueSapMissingController.prototype.toggleFilter = function () {
        if (this.isFilterToggled) {
            this.applyFilter();
        }
        this.isFilterToggled = !this.isFilterToggled;
    };
    QueueSapMissingController.prototype.saveFilter = function () {
        var filterFound = false;
        if (typeof this.userFilters !== 'undefined') {
            for (var i = 0; i < this.userFilters.length; i++) {
                if (this.userFilters[i].name === this.newSearch) {
                    filterFound = true;
                    this.userFilters[i].goeFilter = this.goeFilter;
                    this.userFilters[i].filterSubStatuses = this.filterSubStatuses;
                    this.userFilters[i].filterStatuses = this.filterStatuses;
                    this.userFilters[i].filterCountries = this.filterCountries;
                    this.userFilters[i].filterImts = this.filterImts;
                    this.userFilters[i].filterIots = this.filterIots;
                    break;
                }
            }
        }
        if (!filterFound) {
            var saveSearchObj = {};
            saveSearchObj.name = this.newSearch;
            saveSearchObj.filterSubStatuses = this.filterSubStatuses;
            saveSearchObj.filterStatuses = this.filterStatuses;
            saveSearchObj.filterCountries = this.filterCountries;
            saveSearchObj.filterImts = this.filterImts;
            saveSearchObj.filterIots = this.filterIots;
            saveSearchObj.goeFilter = this.goeFilter;
            if (typeof this.userFilters !== 'undefined') {
                this.userFilters.push(saveSearchObj);
            }
            else {
                this.userFilters = [saveSearchObj];
            }
        }
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                function: 'SaveFilter',
                script: '/queueservice/filterprofiles',
                user: this.env.user,
                data: this.userFilters
            }
        });
    };
    QueueSapMissingController.prototype.changeSavedFilter = function (filter) {
        this.filterIots = filter.filterIots;
        this.filterImts = filter.filterImts;
        this.filterCountries = filter.filterCountries;
        this.filterStatuses = filter.filterStatuses;
        this.filterSubStatuses = filter.filterSubStatuses;
        this.goeFilter = filter.goeFilter;
    };
    QueueSapMissingController.prototype.deleteProfile = function (profile) {
        this.allowed = true;
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                function: 'deleteProfile',
                script: '/queueservice/filterprofiles',
                user: this.env.user.email,
                data: profile,
                token: this.env.user.token
            }
        });
    };
    QueueSapMissingController.prototype.toggleFilterTriggered = function (value) {
        if (value === 'active') {
            this.filterActive = true;
        }
        else if (value === 'inactive') {
            this.filterActive = false;
        }
        else {
            this.filterActive = undefined;
        }
        this.applyFilter();
    };
    QueueSapMissingController.prototype.getVersionLabel = function (ver) {
        switch (ver) {
            case 1:
            case 2:
                return 'CVR';
            case 3:
                return 'SWDR';
            default:
                return '';
        }
    };
    QueueSapMissingController.$inject = [
        '$scope', 'env', '$filter', '$timeout', '$q', 'socket',
        'DTS', 'DTOptionsBuilder', 'DTColumnBuilder', '_',
        '$compile', '$state', '$stateParams', 'notify', 'Dialog', 'settings', '$mdDialog',
    ];
    return QueueSapMissingController;
}());
var QueueSapMissingComponent = (function () {
    function QueueSapMissingComponent() {
        this.templateUrl = 'sap-missing.html';
        this.controllerAs = 'vm';
        this.controller = QueueSapMissingController;
    }
    return QueueSapMissingComponent;
}());
angular
    .module('application')
    .component('queueSapMissingSection', new QueueSapMissingComponent());

//# sourceMappingURL=queue.sap-missing.component.js.map
